<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uKbFrF/tc-custom/9781504011808.jpg?1728851674283" alt="This image is the cover for the book Tortuga"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tortuga
      </h1>
      <p class="bookDescription body article font2">
        <b>American Book Award Winner: A novel of a New Mexico teenager’s journey of physical and spiritual recovery from the author of <i>Bless Me, Ultima</i>.</b><br/><br/> When the story opens, the eponymous hero of Rudolfo Anaya’s novel is in an ambulance en route to a hospital for crippled children in the New Mexican desert. A poor boy from Albuquerque, sixteen-year-old Tortuga takes his name from the odd, turtle-shaped mountain that is rumored to possess miraculous curative powers. Tortuga is paralyzed, and not even his mother’s fervent prayers can heal him. But under the mountain’s watchful gaze, with the support of fellow patients, he begins the Herculean task of breaking out of his shell and becoming whole again.<br/><br/> Drawn from personal experience and imbued with the phantasmagorical vision quests that distinguish Anaya’s work, <i>Tortuga</i> is a joyful, life-sustaining book about hope, faith, friendship, and love that celebrates the triumph of the human spirit in the physical world.<br/><br/> “An extraordinary storyteller.” —<i>Los Angeles Times Book Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rudolfo Anaya
      </h2>
      
      <p class="authorDescription body article">Rudolfo Anaya is professor emeritus of English at the University of New Mexico. He has received numerous literary awards, including the Premio Quinto Sol and a National Medal of Arts. He is the author of the classic work&#160;<I>Bless Me, Ultima</I>, which was chosen for the National Endowment for the Arts&rsquo; Big Read. Anaya&rsquo;s other books for adults include&#160;<I>Tortuga</I>,&#160;<I>Heart of Aztlan</I>,<I>&#160;Alburquerque</I>,<I>&#160;Rio Grande Fall</I>,<I>&#160;Shaman Winter</I>,<I>&#160;Jemez Spring</I>,<I>&#160;Serafina&rsquo;s Stories</I>,<I>&#160;The Man Who Could Fly and Other Stories</I>,&#160;and&#160;<I>Rudolfo Anaya: The Essays.</I>&#160;His children&rsquo;s books include&#160;<I>Farolitos of Christmas</I>,<I>&#160;My Land Sings</I>,<I>&#160;Elegy on the Death of C&eacute;sar Ch&aacute;vez</I>,<I>&#160;Roadrunner&rsquo;s Dance</I>, and&#160;<I>The First Tortilla</I>.&#160;<I>Bless Me, Ultima</I>&#160;was adapted into a feature film in 2013. Anaya resides in Albuquerque, New Mexico.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?97fe2764